const columns = [
	{
		label: 'Status',
		msgKey: 'SWCC000830',
		prop: 'procStatus',
		custom: true,
		width: 80
	},
	{
		label: 'Program ID',
		msgKey: 'SWCC000366',
		prop: 'pgmId',
		width: 150
	},
	{
		label: 'Process ID',
		msgKey: 'SWCC000836',
		prop: 'procId',
		width: 200
	},
	{
		label: '프로그램',
		msgKey: 'SWCC000371',
		prop: 'pgmName',
		width: 250
	},
	{
		label: 'Process Name',
		msgKey: 'SWCC000285',
		prop: 'procName',
		width: 300
	},
	{
		label: 'CTS',
		msgKey: 'SWCC000823',
		prop: 'cts',
		width: 100
	},
	{
		label: 'STS',
		msgKey: 'SWCC000822',
		prop: 'sts',
		width: 100
	},

	{
		label: 'Heart Date Time',
		msgKey: 'SWCC000825',
		prop: 'heartDt',
		width: 200
	},
	{
		label: 'Message',
		msgKey: 'SWCC000826',
		prop: 'message',
		width: 150
	},
	{
		label: 'Queue ID',
		msgKey: 'SWCC000827',
		prop: 'queueId',
		width: 200
	},
	{
		label: 'Execute File',
		msgKey: 'SWCC000824',
		prop: 'exeFile',
		width: 150
	}
];

export default columns;
